import axios from "@/common/http";

export default {
  state: () => ({
    visible: false,
  }),
  mutations: {
    setOrderVisible(state, data) {
      state.visible = data;
    },
  },
  actions: {
    // 我的订单列表
    async getorderlist({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/points/getorderlist", data);
      return res;
    },
    // 我的积分消费记录接口
    async getconsumptionlist({ commit }, data) {
      console.log(commit);
      const res = await axios.post("/v1/points/getconsumptionlist", data);
      return res;
    },
  },
};
